enum ReportingRegime {
    Refit = 'Refit',
    Mifir = 'Mifir',
    SixDerivatives = 'SixDerivatives',
    SixSecurities = 'SixSecurities',
    OscRewrite = 'OscRewrite',
    AsicOld = 'Asic',
    EmirOld = 'Emir',
    MasOld = 'Mas',
    Iirock = 'Iiroc',
    AsicRewrite = 'AsicRewrite',
    MasRewrite = 'MasRewrite',
    Remit = 'Remit',
    MifirCommodityPosition = 'MifirCp',
    Cat = 'cat',
    MifirTransparency = 'MifirTransparency',
    Sftr = 'Sftr',
    MifirCb = 'MifirCb'
}

export default ReportingRegime;